export const actions = {
    START_FETCH_LISTING: "START_FETCH_LISTING",
    SUCCESSFUL_FETCH_LISTING: "SUCCESSFUL_FETCH_LISTING",
    FAILED_FETCH_LISTING: "FAILED_FETCH_LISTING",
    SET_QUERY_PARAMS: "SET_QUERY_PARAMS",
};

export const initialState = {};

export default (state = initialState, { type, response, name, params }) => {
    switch (type) {
        case actions.SET_QUERY_PARAMS: {
            return {
                ...state,
                queryParams: response,
            };
        }
        case actions.START_FETCH_LISTING: {
            return {
                ...state,
                [name]: {
                    queryParams: params,
                },
            };
        }
        default:
            return state;
    }
};
